import { Injectable } from '@angular/core';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { EmpresasBloqueadas } from 'src/app/model/empresas-bloqueadas.model';
import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EmpresasBloqueadasService extends FgiBackEndService<EmpresasBloqueadas> {

  getNewEntity():EmpresasBloqueadas {
    return new EmpresasBloqueadas();
  }

  // @Override
  protected getResourceURL(): string {
    return 'front/empresas-bloqueadas';
  }

  consultarCnpjLote(cnpjs): Observable<Array<EmpresasBloqueadas>> {

    const options: any = blockUi();
    
    let encoded = cnpjs;
    
    return this.http.post(`${this.BASE_URL}/protocolar/lote`, encoded, options).pipe(
           catchError((e) => this.handleError(e))) as Observable<Array<EmpresasBloqueadas>>;
  }
  
  consultaIndividual(cnpj: string) {
    return this.http.post(`${this.BASE_URL}/protocolar`, { cnpj1: cnpj }).pipe(
      catchError((e) => this.handleError(e)));
  }

}
